import Axios from 'axios'
import { token} from '../helpers'
export const AreaService = {
    get(params) {
        return Axios.get(`/api/area/filter`, { params: { ...token(), ...params } }).then(response => {
            return Promise.resolve(response)
        }).catch((error) => {
            return Promise.reject(error)
        })
    },
}